import { createContext } from 'react'
import type { useSocialMedia } from 'src/hooks/socialMedia'
import type { useMyInfo } from 'src/services/apollo/auth'
import type { useGetMyReferrerId } from 'src/services/apollo/referral'
import type { useGetSuggestUsernames } from 'src/services/apollo/user'
import type { useOnboardingData } from './helper'

export interface NewUserOnboardingContextValue {
  goToNextStepWithAction: (action?: () => Promise<void>) => void
  backToLastStep: () => void
  skipStep: () => void
  actionBusy: boolean
  currentStep: number
  totalStep: number
  userInfoRes?: ReturnType<typeof useMyInfo>
  getMyReferrerIdRes?: ReturnType<typeof useGetMyReferrerId>
  getSuggestUsernamesRes?: ReturnType<typeof useGetSuggestUsernames>
  onboardingDataRes?: ReturnType<typeof useOnboardingData>
  socialMediaDataRes?: ReturnType<typeof useSocialMedia>
}

export const NewUserOnboardingContext =
  createContext<NewUserOnboardingContextValue>({
    goToNextStepWithAction: () => {},
    backToLastStep: () => {},
    skipStep: () => {},
    currentStep: 0,
    totalStep: 0,
    actionBusy: false,
  })
